<template>
        <!-- color="white" -->
    <v-select
        class="language"  
        :dark="false"
        flat
        dense
        solo
        v-model="lang"
        :items="items"
        :label="'Language'"/>  
</template>

<script>
export default {
    props: {
        dark: {
            type: Boolean,
            required: false,
            default: function(){
                return false
            }
        }
    },
    name: "Language",
    created: function(){
        this.init()
    },
    data: function(){
        return {
            lang: null
        }
    },
    methods: {
        init: function(){
            let queryLanguage = this.$route.query.language ? this.$route.query.language : false
            let cookieLanguage = this.cache.storage.local.get('language')
            let browserLanguage = navigator.userLanguage || navigator.language;
            let browserLangPrimaryCode = browserLanguage.toLowerCase().split('-')[0]

            this.lang = queryLanguage ? queryLanguage : cookieLanguage ? cookieLanguage : browserLangPrimaryCode && this.returnMap(this.items,'value') ? `${browserLangPrimaryCode}-ca` : this.language

            let languages = [this.lang]

            for(let i=0; i<this.items.length; i++){
                let item = this.items[i]
                if(item.value!=this.lang){
                    languages.push(item.value)
                }
            }

            this.$store.commit('languages',languages)
        },
        returnMap: function(array, index){
            let output = {}

            for(let i=0; i<array.length; i++){
                let item = array[i]
                output[item[index]] = item
            }


            return output
        }
    },
    computed: {
        language: function(){
            return this.$store.getters.language
        },
        items: function(){
            return [
                {text:'English',value:'en-ca'},
                {text:'Français',value:'fr-ca'}
            ]
        }
    },
    watch: {
        language: function(){
            this.lang = this.$store.getters.language
        },
        lang: function(){
            this.cache.storage.local.set('language',this.lang)
            this.$store.commit('language',this.lang)
        }
    }
}
</script>

<style>
.theme--light .v-text-field--solo.language .v-input__control .v-input__slot{
    background-color: transparent !important;    
}
</style>